import { CssBaseline } from '../CssBaseline/CssBaseline'
import { FC, PropsWithChildren } from 'react'
import { ThemeProvider as MuiThemeProvider } from '@mui/material'
import { theme2 } from '../../theme'

export const Theme2Provider: FC<PropsWithChildren<unknown>> = ({ children }) => (
  <MuiThemeProvider theme={theme2}>
    <CssBaseline />
    {children}
  </MuiThemeProvider>
)
